const SgiSplitterEO = function () {
    return {
        cid: '',// 控件编号
        ctlH: '100%',
        ctlN: "分割面板",
        ctlW: '100%',
        desId: "EP_EO_UI_4101",
        isBrdr: false,
        isEdwSpt: false,//纵向分割
        // isHdn: false,
        mgn: "0 0 0 0",
        pad: "0 0 0 0",
        sptLnW: 5,
        sptSca: "",//分割比例
    }
}
export { SgiSplitterEO };
export default SgiSplitterEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiSplitterEO.js